import { styled } from '@bob/library'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid ${({ theme }: { theme: any }) => theme.color.grayLight};
`
